<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="d-inline-block mb-0 me-4">{{ $t("content.amnusermanage") }}</h5>
                  <div>
                    <material-button color="primary" class="float-lg-start float-sm-end mb-0" @click="setadd">
                      <i class="material-icons material-symbols-outlined">add</i>
                       {{ $t("content.addnewusers") }}
                    </material-button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="row">

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.empnumber") }}</label>
                    <material-input v-model="empNum" placeholder="Employee Number" type="text"/>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      @click="loadDataApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.empnumber") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.cemail") }}</th>
                          <th>{{ $t("content.emplv") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- ใช้ <template v-for> ครอบเพื่อสลับแสดงแถวหลักและแถวย่อยคู่กัน -->
                        <template v-for="(row, index) in listdata" :key="row.uid || index">
                          <tr
                            class="user-row-hover"
                            :class="{ 'table-active': isExpanded(row || index) }"
                            :style="{
                              cursor: isDisabledUser(row) ? 'default' : 'pointer',
                              opacity: isDisabledUser(row) ? '0.65' : '1',
                              backgroundColor: isDisabledUser(row) ? '#f8fafc' : 'transparent'
                            }"
                            @click="!isDisabledUser(row) ? toggleRow(row || index) : null"
                          >
                            <!-- คอลัมน์ที่ 1: ตัวเลขลำดับธรรมดา (ถอดปุ่มลูกศรออกแล้ว) -->
                            <td class="text-sm font-weight-normal align-middle">
                              {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                            </td>
                            <td class="text-sm font-weight-normal align-middle">
                              {{ row.employeeNumber }}
                            </td>
                            <td class="text-sm font-weight-normal align-middle">
                              {{ row.nameTh }} ({{ row.nameEn }})
                            </td>
                            <td class="text-sm font-weight-normal align-middle">
                              {{ row.email }}
                            </td>
                            <td class="text-sm font-weight-normal align-middle">
                              <span v-if="row.userLevel === 'admin'" style="color:red; font-weight: bold;">Admin</span>
                              <span v-else >User</span>  
                            </td>
                            
                            <!-- คอลัมน์ที่ 7: กลุ่มปุ่มจัดการต่างๆ (ใส่ @click.stop เพื่อไม่ให้คลิกปุ่มแล้วแถวหุบเข้า) -->
                            <td class="text-sm font-weight-normal align-middle" @click.stop>
                              <div class="flex items-center gap-1 justify-end">
                                <material-button color="success" variant="outline" class="rounded-circle" :title="$t('content.uschedule')"
                                  @click="findShops(row,'schedule')" :disabled="isDisabledUser(row)">
                                  <i class="material-icons material-symbols-outlined">calendar_month</i>
                                </material-button>
                                <material-button color="info" variant="outline" class="rounded-circle" :title="$t('content.editusers')"
                                 @click="findShops(row,'edit')" :disabled="isDisabledUser(row)">
                                  <i class="material-icons material-symbols-outlined">edit</i>
                                </material-button>
                                <material-button color="warning" variant="outline" class="rounded-circle" :title="$t('content.resetpwd')"
                                 @click="findShops(row,'reset')" :disabled="isDisabledUser(row)">
                                  <i class="material-icons material-symbols-outlined">key</i>
                                </material-button>
                                <material-button color="danger" variant="outline" class="rounded-circle" :title="$t('content.deleteusers')"
                                  @click="findShops(row,'delete')"  :disabled="isDisabledUser(row)">
                                  <i class="material-icons material-symbols-outlined">delete</i>
                                </material-button>
                              </div>
                            </td>     
                          </tr>
                          <!-- 2. แถวขยายข้อมูลย่อย (Sub-table Row) ดีไซน์ใหม่ให้สะอาดตา -->
                          <tr v-if="isExpanded(row.uid || index)">
                            <td colspan="7" class="p-0" style="background-color: #fafbfc;">
                              <div class="px-5 py-4 bg-white border-bottom">
                                
                                <!-- ส่วนหัวตารางย่อยแบบ Minimal -->
                                <div class="d-flex justify-content-between align-items-center mb-4">
                                  <div class="fw-bold tracking-wide" style="font-size: 13px; color: #4e5d78; letter-spacing: 0.5px;">
                                    SHOP ASSIGNMENTS — <span class="text-success fw-normal">{{ row.nameTh }}</span>
                                  </div>
                                  <!-- ปุ่ม Assign Design ใหม่ให้ดูเบาและสะอาดขึ้น -->
                                  <button class="btn btn-outline-success btn-sm border-dashed rounded px-3 py-1.5" style="border-style: dashed; font-size: 11px; font-weight: 500;"
                                    @click="openAssignShopModal(row)" :disabled="row.userLevel === 'admin'">
                                    + ASSIGN TO SHOP
                                  </button>
                                </div>

                                <!-- ตารางรายชื่อสาขาแบบสะอาดตา (Clean & Flat Style) -->
                                <table class="table table-sm mb-0 align-middle" style="--bs-table-bg: transparent;">
                                  <thead>
                                    <tr class="text-muted text-uppercase fw-semibold" style="font-size: 11px; letter-spacing: 0.5px; border-bottom: 1px solid #edf2f7;">
                                      <th style="width: 80px; padding-bottom: 12px; font-weight: 600; color: #ffffff;">Shop</th>
                                      <th style="padding-bottom: 12px; font-weight: 600; color: #ffffff;">Shop Name</th>
                                      <th style="padding-bottom: 12px; font-weight: 600; color: #ffffff;">Role</th>
                                      <th class="text-end" style="width: 100px; padding-bottom: 12px;"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <!-- สถานะที่ 1: ระบบกำลังรอโหลดข้อมูลจาก API (ค่าเป็น null) -> แสดง Spinner หมุนโหลดนิ่งๆ -->
                                    <tr v-if="expandedRowData === null">
                                      <td colspan="4" class="text-center py-5">
                                        <div class="d-flex flex-column align-items-center justify-content-center text-secondary">
                                          <div class="spinner-border spinner-border-sm text-success mb-2" role="status" style="width: 1.5rem; height: 1.5rem;"></div>
                                          <span style="font-size: 13px; color: #64748b;">กำลังโหลดข้อมูลสาขา...</span>
                                        </div>
                                      </td>
                                    </tr>

                                    <!-- สถานะที่ 2: โหลดเสร็จสมบูรณ์แล้ว และข้อมูล "มีรายการสาขา" (> 0) -> ลูปแสดงตารางปกติ -->
                                    <template v-else-if="expandedRowData && expandedRowData.length > 0">
                                        <tr v-for="(shop, sIdx) in expandedRowData" :key="sIdx" style="border-bottom: 1px solid #f7fafc;">
                                        <!-- คอลัมน์รหัสย่อสาขา -->
                                        <td class="py-3">
                                            <span class="badge px-2 py-1 rounded" 
                                                  style="font-size: 11px; min-width: 38px; font-weight: 600;"
                                                  :style="{
                                                      background: shopBg(shop.shopUid),
                                                      color: shopColor(shop.shopUid),
                                                      border: `1px solid ${shopBorder(shop.shopUid)}`
                                                  }">
                                                {{ shopList.find(s => s.uid === shop.shopUid)?.code || 'กำลังโหลดรหัสสาขา...' }}
                                            </span>
                                        </td>
                                        <!-- คอลัมน์ชื่อเต็มสาขา -->
                                        <td class="py-3 text-sm text-secondary" style="font-size: 14px; color: #4a5568 !important;">
                                          {{ shopList.find(s => s.uid === shop.shopUid)?.nameTh || 'กำลังโหลดชื่อสาขา...' }}
                                        </td>
                                        <!-- คอลัมน์บทบาทหน้าที่ -->
                                        <td class="py-2 align-middle">
                                          <span class="badge rounded-pill px-3 py-1.5 fw-semibold" 
                                              :style="getRoleBadgeStyle(shop.businessRole)" 
                                                style="font-size: 14px; letter-spacing: 0.3px;">
                                            {{ shop.businessRole }}
                                          </span>
                                        </td>
                                        <!-- ปุ่มคำสั่งจัดการสาขา -->
                                        <td class="py-3 text-end align-middle px-3">
                                          <div class="d-inline-flex align-items-center gap-4 justify-content-end">
                                            
                                            <!-- 1. ปุ่ม Set PIN -->
                                            <span 
                                              v-if="shop.businessRole === 'SHOP_MANAGER'"
                                              class="fw-normal d-inline-flex align-items-center text-nowrap" 
                                              :class="shop.shopUid !== key?.uid ? 'text-muted' : 'subt-btn cursor-pointer'"
                                              :style="{ 
                                                fontSize: '14px', 
                                                color: shop.shopUid !== key?.uid ? '#cbd5e1' : '#4f46e5', 
                                                fontWeight: '500',
                                                pointerEvents: shop.shopUid !== key?.uid ? 'none' : 'auto' 
                                              }"
                                              @click="shop.shopUid === key?.uid ? openSetPinModal(row, shop) : null"
                                            >
                                              <span class="material-icons me-1" :style="{ fontSize: '15px', verticalAlign: middle, color: shop.shopUid !== key?.uid ? '#cbd5e1' : '#4f46e5' }">gpp_good</span>
                                              Set PIN
                                            </span>

                                            <!-- 2. ปุ่ม Update -->
                                            <span 
                                              class="fw-normal text-nowrap" 
                                              :class="shop.shopUid !== key?.uid ? 'text-muted' : 'subt-btn' "
                                              :style="{ 
                                                cursor: shop.shopUid !== key?.uid ? 'default' : 'pointer', 
                                                fontSize: '14px', 
                                                color: shop.shopUid !== key?.uid ? '#cbd5e1' : '#f59e0b', 
                                                fontWeight: '500',
                                                pointerEvents: shop.shopUid !== key?.uid ? 'none' : 'auto'
                                              }"
                                              @click="shop.shopUid === key?.uid ? openEditAssignShopModal(row, shop) : null"
                                            >
                                              Update
                                            </span>

                                            <!-- 3. ปุ่ม Remove -->
                                            <span 
                                              class="fw-normal text-nowrap" 
                                              :class="shop.shopUid !== key?.uid ? 'text-muted' : 'subt-btn'"
                                              :style="{ 
                                                cursor: shop.shopUid !== key?.uid ? 'default' : 'pointer', 
                                                fontSize: '14px', 
                                                color: shop.shopUid !== key?.uid ? '#cbd5e1' : '#f43f5e', 
                                                fontWeight: '500',
                                                pointerEvents: shop.shopUid !== key?.uid ? 'none' : 'auto'
                                              }"
                                              @click="shop.shopUid === key?.uid ? openRemoveShopModal(row, shop) : null"
                                            >
                                              Remove
                                            </span>

                                          </div>
                                        </td>
                                      </tr>
                                    </template>

                                    <!-- สถานะที่ 3: 💡 ปรับปรุงตรงนี้เพื่อแก้ปัญหากระตุก -->
                                    <!-- โหลดเสร็จแล้ว ชนิดข้อมูลต้องเป็น Array เปล่าจริงๆ เท่านั้น (expandedRowData.length === 0) ถึงจะยอมให้ป้ายเตือนแสดงผล -->
                                    <template v-else-if="expandedRowData && expandedRowData.length === 0">
                                      <tr>
                                        <td colspan="4" class="text-center py-5">
                                          <div class="d-flex flex-column align-items-center justify-content-center text-muted">
                                            <span class="material-icons mb-2" style="font-size: 32px; color: #cbd5e1;">inventory_2</span>
                                            <span style="font-size: 14px; color: #64748b; font-weight: 500; letter-spacing: 0.3px;">
                                              ไม่พบข้อมูลการมอบหมายสาขา
                                            </span>
                                            <span class="small text-nowrap mt-1" style="font-size: 14px; color: #94a3b8;">
                                              คลิกปุ่ม "+ ASSIGN TO SHOP" ด้านบนเพื่อเพิ่มสาขาให้พนักงานคนนี้
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </table>

                              </div>
                            </td>
                          </tr>

                        </template>

                        <tr v-if="listdata.length === 0">
                          <td colspan="7" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="9" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listdata.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>


        <!-- Add New Dialog -->
        <div id="newUsersModal" class="modal fade" tabindex="-1" aria-labelledby="newUsersModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 640px;">
            <div class="modal-content border-0 shadow-lg overflow-hidden" style="border-radius: 12px;">
              
              <!-- MODAL HEADER -->
              <div class="px-4 py-3 text-white d-flex justify-content-between align-items-center" style="background-color: #00b074;">
                <h4 class="modal-title fw-bold m-0" style="font-size: 20px; letter-spacing: 0.3px;color: #ffffff !important;">เพิ่มผู้ใช้งานใหม่</h4>
                <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <!-- MODAL BODY -->
              <div class="modal-body px-4 py-4 bg-white" style="max-height: 80vh; overflow-y: auto;">
                  <div class="row g-3">
                    
                    <!-- แถวที่ 1: รหัสพนักงาน และ ระดับผู้ใช้งาน -->
                    <div class="col-6 m-0">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">รหัสพนักงาน <span class="text-danger">*</span></label>
                      <div v-if="errors.employeeNumber" class="text-danger mb-1" style="font-size: 11px; line-height: 1.3;">
                        รหัสพนักงานต้องกรอกให้ครบถ้วนและขึ้นต้นด้วย BDM
                      </div>
                      <input 
                        type="text" 
                        v-model="form.employeeNumber" 
                        @input="validateEmployeeNumber"
                        class="form-control form-control-sm rounded shadow-none w-100" 
                        :class="{ 'is-invalid': errors.employeeNumber }"
                        placeholder="BDM0010" 
                        required 
                        style="padding: 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px;background-image: none !important;"
                      >
                    </div>

                    <div class="col-6 m-0">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">ระดับผู้ใช้งาน</label>
                      <div v-if="errors.employeeNumber" class="mb-1" style="height: 14.3px;"></div>
                      <input 
                        type="text" 
                        v-model="form.userLevel" 
                        class="form-control form-control-sm rounded shadow-none text-muted w-100" 
                        readonly 
                        style="background-color: #f1f5f9 !important; padding: 0.45rem 0.75rem; border-color: #e2e8f0 !important; font-size: 13.5px; height: 36px;background-image: none !important;"
                      >
                    </div>

                    <!-- แถวที่ 2: ชื่อไทย และ Name EN -->
                    <div class="col-6 mt-2">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">ชื่อ (ไทย) <span class="text-danger">*</span></label>
                      <div v-if="errors.nameTh" class="text-danger mb-1" style="font-size: 11px; line-height: 1.3;">
                        กรุณากรอกชื่อ-นามสกุลภาษาไทย
                      </div>
                      <input 
                        type="text" 
                        v-model="form.nameTh" 
                        class="form-control form-control-sm rounded shadow-none w-100" 
                        :class="{ 'is-invalid': errors.nameTh }"
                        placeholder="ชื่อ นามสกุล" 
                        required 
                        style="padding: 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px;background-image: none !important;"
                      >
                    </div>

                    <div class="col-6 mt-2">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">Name (EN)</label>
                      <div v-if="errors.nameTh" class="mb-1" style="height: 14.3px;"></div>
                      <input 
                        type="text" 
                        v-model="form.nameEn" 
                        class="form-control form-control-sm rounded shadow-none w-100" 
                        placeholder="First Last" 
                        style="padding: 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px;background-image: none !important;"
                      >
                    </div>


                    <!-- แถวที่ 3: อีเมล -->
                    <div class="col-12 mt-2">
                      <!-- 1. ส่วนแบรนดิ้ง/ป้ายกำกับ -->
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">
                        อีเมล <span class="text-danger">*</span>
                      </label>
                      
                      <!-- 2. กล่องข้อความแจ้งเตือนตัวแดง (แสดงแบบ Real-time หลังจากหยุดพิมพ์ หรือตอน Blur) -->
                      <div v-if="errors.email" class="text-danger mb-1" style="font-size: 11px; line-height: 1.3;">
                        กรุณากรอกอีเมลองค์กร โดยชื่อผู้ใช้ต้องมีจุด (.) เพียงจุดเดียวเท่านั้น (เช่น firstname.l@ibuddy.biz)
                      </div>
                      
                      <!-- 3. ช่องอินพุตกรอกอีเมล -->
                      <input 
                        type="email" 
                        v-model.trim="form.email" 
                        @input="handleEmailInput" 
                        @blur="fixEmailSuffix"
                        class="form-control form-control-sm rounded shadow-none w-100" 
                        :class="{ 'is-invalid': errors.email }"
                        placeholder="firstname.l@ibuddy.biz" 
                        required 
                        style="padding: 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px; background-image: none !important;"
                      >
                    </div>


                    <!-- แถวที่ 4: Username -->
                    <div class="col-12 mt-2">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">Username (auto-fill from email)</label>
                      <input 
                        type="text" 
                        v-model="form.username" 
                        class="form-control form-control-sm rounded shadow-none text-muted w-100" 
                        placeholder="auto-filled" 
                        readonly 
                        style="background-color: #f1f5f9 !important; padding: 0.45rem 0.75rem; border-color: #e2e8f0 !important; font-size: 13.5px; height: 36px;"
                      >
                    </div>

                    <!-- แถวที่ 5: ส่วน SET PASSWORD แบบแก้ระนาบและจัดปุ่มตาใหม่ -->
                    <div class="col-12 mt-4 pt-1">
                      <!-- หัวข้อหลักกลุ่มตั้งรหัสผ่าน -->
                      <div class="text-uppercase tracking-wider fw-bold text-secondary mb-1" style="font-size: 11px; color: #94a3b8 !important; letter-spacing: 0.5px;">SET PASSWORD</div>
                      
                      <!-- ข้อความแจ้งเตือนเงื่อนไขหลักสีแดงลอยอยู่ใต้คำว่า SET PASSWORD -->
                      <div v-if="errors.password" class="text-danger mb-3" style="font-size: 11px; line-height: 1.4;">
                        รหัสผ่านต้องมีตัวพิมพ์ใหญ่ (A-Z) ตัวพิมพ์เล็ก (a-z) และตัวเลข (0-9)
                      </div>

                      <!-- ข้อความแจ้งเตือนรหัสผ่านไม่ตรงกัน (กรณีช่องสองผิด) จะโผล่ตรงนี้เพื่อไม่ให้ดันโครงสร้างอินพุตด้านล่างเบี้ยว -->
                      <div v-if="shouldShowConfirmError" class="text-danger mb-3" style="font-size: 11px; line-height: 1.3;">
                        รหัสผ่านยืนยันไม่ตรงกับรหัสผ่านหลัก
                      </div>

                      <!-- บรรทัดที่ 1: บล็อกของหัวข้ออักษร (Labels) เรียงระนาบแนวนอนเดียวกัน -->
                      <div class="row g-3 mb-1">
                        <div class="col-6">
                          <label class="form-label small fw-semibold m-0" style="color: #4a5568 !important; font-size: 13.5px;">Password <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-6">
                          <label class="form-label small fw-semibold m-0" style="color: #4a5568 !important; font-size: 13.5px;">Confirm Password <span class="text-danger">*</span></label>
                        </div>
                      </div>

                      <!-- บรรทัดที่ 2: บล็อกของกล่องกรอกข้อความ (Inputs) เรียงระนาบแนวนอนเดียวกันตรงเป๊ะ 100% -->
                      <div class="row g-3">
                        <!-- ช่องรหัสผ่านหลัก -->
                        <div class="col-6">
                          <div class="position-relative">
                            <input 
                              :type="showPassword ? 'text' : 'password'" 
                              v-model="form.password" 
                              class="form-control form-control-sm rounded shadow-none w-100" 
                              :class="{ 'is-invalid': errors.password }"
                              placeholder="••••••••" 
                              required 
                              style="padding: 0.45rem 2.2rem 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px; background-image: none !important;"
                            >
                            <!-- ปุ่มตาแบบ <span> แก้บั๊ก Runtime Error และจัดกึ่งกลางแนวตั้งแม่นยำ -->
                            <span 
                              class="material-icons position-absolute cursor-pointer d-flex align-items-center justify-content-center"
                              style="top: 50%; right: 12px; transform: translateY(-50%); z-index: 5; width: 24px; height: 24px; color: #64748b; user-select: none;"
                              @click="showPassword = !showPassword"
                            >
                              {{ showPassword ? 'visibility_off' : 'visibility' }}
                            </span>
                          </div>
                        </div>

                        <!-- ช่องยืนยันรหัสผ่าน -->
                        <div class="col-6">
                          <div class="position-relative">
                            <input 
                              :type="showConfirmPassword ? 'text' : 'password'" 
                              v-model="form.confirmPassword" 
                              class="form-control form-control-sm rounded shadow-none w-100" 
                              :class="{ 'is-invalid': shouldShowConfirmError }"
                              placeholder="••••••••" 
                              required 
                              style="padding: 0.45rem 2.2rem 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px; background-image: none !important;"
                            >
                            <span 
                              class="material-icons position-absolute cursor-pointer d-flex align-items-center justify-content-center"
                              style="top: 50%; right: 12px; transform: translateY(-50%); z-index: 5; width: 24px; height: 24px; color: #64748b; user-select: none;"
                              @click="showConfirmPassword = !showConfirmPassword"
                            >
                              {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
                            </span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <!-- MODAL FOOTER CONTROLS -->
                <div class="modal-footer border-top-0 px-4 pb-4 pt-1 d-flex justify-content-end align-items-center gap-3 bg-white">
                  <button type="button" class="btn btn-link text-secondary text-decoration-none shadow-none fw-bold p-0" data-bs-dismiss="modal" style="font-size: 14.5px; letter-spacing: 0.3px;">
                    CANCEL
                  </button>
                  <button 
                    type="submit" 
                    class="btn btn-success btn-sm text-white px-4 py-1.5 shadow-none fw-bold rounded-2" 
                    style="min-width: 100px; background-color: #00b074; border: none; font-size: 14.5px; letter-spacing: 0.3px;"
                    :disabled="isFormInvalid" @click="handleAddNewUser"
                  >
                    CREATE
                  </button>
                </div>

              </div>
            </div>
          </div>

        <!-- Edit Confirmation Dialog -->
        <div id="editUserModal" class="modal fade" tabindex="-1" aria-labelledby="editUserModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 650px;">
            <div class="modal-content border-0 shadow-lg overflow-hidden" style="border-radius: 16px;">
              
              <!-- MODAL HEADER: ไล่เฉดสีฟ้าพรีเมียม สไตล์โมเดิร์น สะอาดตา -->
              <div class="p-4 text-white position-relative overflow-hidden" 
                  style="background: linear-gradient(135deg, #3b82f6, #1d4ed8); border-radius: 16px 16px 0 0;">
                <div class="d-flex justify-content-between align-items-center position-relative" style="z-index: 2;">
                  <h4 class="modal-title fw-bold m-0" style="font-size: 20px; letter-spacing: 0.3px;color: #ffffff !important;">
                    แก้ไขข้อมูลผู้ใช้งาน
                  </h4>
                  <!-- ปุ่มปิดกากบาทสีขาวกระจ่างใสสำหรับพื้นหลังสีฟ้า -->
                  <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
              </div>

              <!-- MODAL BODY: (ใช้โครงสร้างช่องกรอกเดิมของคุณได้เลยครับ) -->
              <div class="modal-body px-4 py-4 bg-white">
                  <div class="row g-3">
                    <div class="col-6 m-0">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">รหัสพนักงาน</label>
                      <!-- 🟢 เอาเครื่องหมายดาวแดง * ออก และใส่คลาส bg-light กับคุณสมบัติ readonly ห้ามแก้ -->
                      <input 
                        type="text" 
                        v-model="editForm.employeeNumber" 
                        class="form-control form-control-sm rounded shadow-none text-muted w-100" 
                        readonly
                        style="background-color: #f1f5f9 !important; padding: 0.45rem 0.75rem; border-color: #e2e8f0 !important; font-size: 13.5px; height: 36px;"
                      >
                    </div>
                    
                    <div class="col-6 m-0">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">ระดับผู้ใช้งาน</label>
                      <!-- 🟢 ล็อกถาวรให้เป็นช่องอินพุตปกติแบบ readonly อ่านได้อย่างเดียว เพื่อความสวยงามสมมาตรและห้ามแก้ไข -->
                      <input 
                        type="text" 
                        v-model="editForm.userLevel" 
                        class="form-control form-control-sm rounded shadow-none text-muted w-100" 
                        readonly 
                        style="background-color: #f1f5f9 !important; padding: 0.45rem 0.75rem; border-color: #e2e8f0 !important; font-size: 13.5px; height: 36px;"
                      >
                    </div>

                    <div class="col-md-6">
                      <label class="form-label small fw-semibold text-secondary mb-1">ชื่อ (ไทย)</label>
                      <input type="text" v-model="editForm.nameTh" class="form-control form-control-lg bg-light border-0 py-2 px-3 text-sm rounded-3 shadow-none" placeholder="ชื่อ นามสกุล" required>
                    </div>
                    
                    <div class="col-md-6">
                      <label class="form-label small fw-semibold text-secondary mb-1">Name (EN)</label>
                      <input type="text" v-model="editForm.nameEn" class="form-control form-control-lg bg-light border-0 py-2 px-3 text-sm rounded-3 shadow-none" placeholder="First Last">
                    </div>

                    <div class="col-12 mt-2">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">
                        อีเมล <span class="text-danger">*</span>
                      </label>
                      <!-- ตัวแจ้งเตือนสีแดงอยู่ด้านบนของ Input เหมือนโหมดสร้างผู้ใช้ -->
                      <div v-if="editErrors.email" class="text-danger mb-1" style="font-size: 11px; line-height: 1.3;">
                        กรุณากรอกอีเมลองค์กร โดยชื่อผู้ใช้ต้องมีจุด (.) เพียงจุดเดียวเท่านั้น (เช่น firstname.l@ibuddy.biz)
                      </div>
                      <input 
                        type="email" 
                        v-model.trim="editForm.email" 
                        @input="handleEditEmailInput" 
                        @blur="fixEditEmailSuffix"
                        class="form-control form-control-sm rounded shadow-none w-100" 
                        :class="{ 'is-invalid': editErrors.email }"
                        placeholder="firstname.l@ibuddy.biz" 
                        required 
                        style="padding: 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px; background-image: none !important;"
                      >
                    </div>

                    <div class="col-12 mt-2">
                      <label class="form-label small fw-semibold mb-1" style="color: #4a5568 !important; font-size: 13.5px;">Username (auto-fill from email)</label>
                      <input 
                        type="text" 
                        v-model="editForm.username" 
                        class="form-control form-control-sm rounded shadow-none text-muted w-100" 
                        placeholder="auto-filled" 
                        readonly 
                        style="background-color: #f1f5f9 !important; padding: 0.45rem 0.75rem; border-color: #e2e8f0 !important; font-size: 13.5px; height: 36px;"
                      >
                    </div>

                  </div>
              </div>

              <!-- MODAL FOOTER CONTROLS: ปรับสีปุ่ม SAVE เป็นสีฟ้าและเปลี่ยน CANCEL เป็นสไตล์ตัวหนังสือให้เข้าคู่กัน -->
              <div class="modal-footer border-top-0 px-4 pb-4 pt-2 d-flex justify-content-end align-items-center gap-3 bg-white">
                <button type="button" class="btn btn-link text-secondary text-decoration-none shadow-none text-sm fw-bold p-0" 
                        data-bs-dismiss="modal" style="font-size: 15px; color: #64748b !important; letter-spacing: 0.5px;">
                  CANCEL
                </button>
                
              <!-- ปุ่ม SAVE อัปเดตผูกระบบล็อกฟอร์มและจัดการเปลี่ยนเป็นส่งค่าผ่าน ID ฟอร์มหลัก -->
              <button 
                type="submit" 
                class="btn btn-primary btn-sm text-white px-4 py-1.5 shadow-none fw-bold rounded-2" 
                style="min-width: 100px; background: linear-gradient(135deg, #3b82f6, #1d4ed8); border: none; font-size: 14.5px; letter-spacing: 0.3px;"
                :disabled="isEditFormInvalid" @click="handleUpdateUser"
              >
                SAVE
              </button>
              </div>

            </div>
          </div>
        </div>

        <!-- Reset Password Dialog -->
        <div id="resetPasswordModal" class="modal fade" tabindex="-1" aria-labelledby="resetPasswordModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 500px;">
            <div class="modal-content border-0 shadow-lg overflow-hidden" style="border-radius: 12px;">
              
              <!-- MODAL HEADER -->
              <div class="px-4 py-3 text-white d-flex justify-content-between align-items-center" style="background-color: #f59e0b;">
                <div>
                  <h4 class="modal-title fw-bold m-0" style="font-size: 20px; letter-spacing: 0.3px;color: #ffffff !important;">Reset Password</h4>
                  <!-- 🟢 แก้ไขคีย์การดึงข้อมูลจากโครงสร้างตัวแปรของคุณ (ต้องเป็น resetPwdForm) -->
                  <p class="text-white opacity-85 small mb-0 mt-1" v-if="resetPwdForm.nameTh" style="font-size: 13px;">
                    {{ resetPwdForm.nameTh }} ({{ resetPwdForm.employeeNumber }})
                  </p>
                </div>
                <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <!-- MODAL BODY -->
              <div class="modal-body px-4 py-4 bg-white" style="max-height: 80vh; overflow-y: auto;">
                  <!-- ใช้ row หลักคุมพิกัด และใช้ g-3 ล็อกสเปซระยะย่อหน้าขอบซ้าย-ขวาเท่ากันหมดทุกชั้น -->
                  <div class="row g-3">
                    
                    <!-- 🟢 เอาตัวอักษร SET PASSWORD ออกแล้ว และเหลือแค่ข้อความเตือนสีแดงล็อกขอบซ้ายตรงกับอินพุตเป๊ะ -->
                    <div class="col-12">
                      <!-- แจ้งเตือนเงื่อนไขหลักสีแดงลอยอยู่บนยอดสุด -->
                      <div v-if="resetErrors.password" class="text-danger mb-1" style="font-size: 11px; line-height: 1.4;">
                        รหัสผ่านต้องมีตัวพิมพ์ใหญ่ (A-Z) ตัวพิมพ์เล็ก (a-z) และตัวเลข (0-9)
                      </div>

                      <!-- ข้อความแจ้งเตือนรหัสผ่านไม่ตรงกัน จะโผล่ตรงนี้ร่วมกันเพื่อล็อกไม่ให้ดันระนาบอินพุตด้านล่างเบี้ยว -->
                      <div v-if="shouldShowResetConfirmError" class="text-danger mb-1" style="font-size: 11px; line-height: 1.3;">
                        รหัสผ่านยืนยันไม่ตรงกับรหัสผ่านหลัก
                      </div>
                    </div>

                    <!-- บรรทัดที่ 1: บล็อกของหัวข้ออักษร (Labels) จัดระดับคู่ขนานระนาบแนวนอนเดียวกัน -->
                    <div class="col-6 mt-2">
                      <label class="form-label small fw-semibold m-0" style="color: #4a5568 !important; font-size: 13.5px;">New Password <span class="text-danger">*</span></label>
                    </div>
                    <div class="col-6 mt-2">
                      <label class="form-label small fw-semibold m-0" style="color: #4a5568 !important; font-size: 13.5px;">Confirm Password <span class="text-danger">*</span></label>
                    </div>

                    <!-- บรรทัดที่ 2: บล็อกของกล่องข้อความ (Inputs) ขนานเป็นเส้นตรงระนาบเดียวกัน 100% ไร้เครื่องหมายตกใจ -->
                    <!-- ช่องรหัสผ่านใหม่ -->
                    <div class="col-6 mt-1">
                      <div class="position-relative">
                        <input 
                          :type="showResetPassword ? 'text' : 'password'" 
                          v-model="resetPwdForm.password" 
                          class="form-control form-control-sm rounded shadow-none w-100" 
                          :class="{ 'is-invalid': resetErrors.password }"
                          placeholder="••••••••" 
                          required 
                          style="padding: 0.45rem 2.2rem 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px; background-image: none !important;"
                        >
                        <!-- ปุ่มตาแบบ <span> ป้องกัน Ripple Effect ตกค้าง และล็อกอยู่กึ่งกลางแนวตั้งพอดีตา -->
                        <span 
                          class="material-icons position-absolute cursor-pointer d-flex align-items-center justify-content-center"
                          style="top: 50%; right: 12px; transform: translateY(-50%); z-index: 5; width: 24px; height: 24px; color: #64748b; user-select: none;"
                          @click="showResetPassword = !showResetPassword"
                        >
                          {{ showResetPassword ? 'visibility_off' : 'visibility' }}
                        </span>
                      </div>
                    </div>

                    <!-- ช่องยืนยันรหัสผ่านใหม่ -->
                    <div class="col-6 mt-1">
                      <div class="position-relative">
                        <input 
                          :type="showResetConfirmPassword ? 'text' : 'password'" 
                          v-model="resetPwdForm.confirmPassword" 
                          class="form-control form-control-sm rounded shadow-none w-100" 
                          :class="{ 'is-invalid': shouldShowResetConfirmError }"
                          placeholder="••••••••" 
                          required 
                          style="padding: 0.45rem 2.2rem 0.45rem 0.75rem; border-color: #cbd5e1 !important; font-size: 13.5px; height: 36px; background-image: none !important;"
                        >
                        <span 
                          class="material-icons position-absolute cursor-pointer d-flex align-items-center justify-content-center"
                          style="top: 50%; right: 12px; transform: translateY(-50%); z-index: 5; width: 24px; height: 24px; color: #64748b; user-select: none;"
                          @click="showResetConfirmPassword = !showResetConfirmPassword"
                        >
                          {{ showResetConfirmPassword ? 'visibility_off' : 'visibility' }}
                        </span>
                      </div>
                    </div>

                  </div>
              </div>

              <!-- MODAL FOOTER CONTROLS -->
              <div class="modal-footer border-top-0 px-4 pb-4 pt-1 d-flex justify-content-end align-items-center gap-3 bg-white">
                <button type="button" class="btn btn-link text-secondary text-decoration-none shadow-none fw-bold p-0" data-bs-dismiss="modal" style="font-size: 14.5px; letter-spacing: 0.3px;">
                  CANCEL
                </button>
                <button 
                  type="submit" 
                  class="btn btn-warning btn-sm text-white px-4 py-1.5 shadow-none fw-bold rounded-2" 
                  style="min-width: 130px; background: linear-gradient(135deg, #f59e0b, #d97706); border: none; font-size: 14.5px; letter-spacing: 0.3px;"
                  :disabled="isResetFormInvalid" @click="handleResetPassword"
                >
                  SET PASSWORD
                </button>
              </div>

            </div>
          </div>
        </div>



        <!-- Delete User Dialog -->
        <div id="deleteUserModal" class="modal fade" tabindex="-1" aria-labelledby="deleteUserModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 460px;">
            <div class="modal-content border-0 shadow-lg p-4 text-center" style="border-radius: 16px;">
              
              <!-- MODAL BODY: จัดตำแหน่งให้อยู่ตรงกลางทั้งหมด -->
              <div class="modal-body p-0">
                
                <!-- ไอคอนรูปคนสีแดงในวงกลมสีชมพูอ่อน ตามภาพ UI -->
                <div class="d-flex align-items-center justify-content-center mx-auto mb-3" 
                    style="width: 70px; height: 70px; background-color: #ffe8e8; border-radius: 50%;">
                  <span class="material-icons text-danger" style="font-size: 32px;">person_outline</span>
                </div>

                <!-- หัวข้อลบผู้ใช้งาน -->
                <h4 class="fw-bold mb-2" style="color: #2d3748; font-size: 22px;">Delete User</h4>
                
                <!-- ข้อความแจ้งเตือนดึงค่าตามพนักงานที่เลือก -->
                <p class="text-secondary mb-4 px-2" style="font-size: 15px; color: #718096 !important;">
                  ลบ <span class="fw-bold" style="color: #4a5568;">{{ deleteForm.nameTh }} ({{ deleteForm.employeeNumber }})</span> ออกจากระบบถาวร
                </p>

                <!-- กลุ่มปุ่มกดยืนยันการลบ จัดแบบแนวนอนขนานกันคู่กัน -->
                <div class="d-flex justify-content-center gap-3">
                  <button type="button" class="btn btn-light text-secondary fw-semibold border-0 px-4 py-2 rounded-3 shadow-none" 
                          data-bs-dismiss="modal" style="background-color: #f1f3f9; min-width: 110px; font-size: 14px;">
                    Cancel
                  </button>
                  
                  <button type="button" class="btn btn-danger fw-semibold px-4 py-2 rounded-3 shadow-none" 
                          style="background-color: #e53e3e; border: none; min-width: 110px; font-size: 14px;"
                          @click="handleDeleteUser">
                    Delete
                  </button>
                </div>

              </div>

            </div>
          </div>
        </div>


        <div id="setPinModal" class="modal fade" tabindex="-1" aria-labelledby="setPinModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 540px;">
            <div class="modal-content border-0 shadow-lg overflow-hidden" style="border-radius: 28px;">
              
              <!-- MODAL HEADER: เปลี่ยนเป็นสีม่วงสดใสและมนรับกับดีไซน์ตาม UI จริง -->
              <div class="p-4 text-white pb-3" style="background: linear-gradient(135deg, #a855f7, #7c3aed);">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 class="modal-title fw-bold m-0" style="font-size: 20px; letter-spacing: 0.3px;color: #ffffff !important;">Set PIN</h4>
                    <p class="text-white opacity-85 small mb-0 mt-2" v-if="setPinForm.nameTh" style="font-size: 15px;">
                      {{ setPinForm.nameTh }} ({{ setPinForm.employeeNumber }}) — {{ setPinForm.shopCode }}
                    </p>
                  </div>
                  <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal" aria-label="Close" style="font-size: 14px;"></button>
                </div>
              </div>

              <!-- MODAL BODY -->
              <div class="modal-body px-4 pt-4 pb-3 bg-white">
                  <!-- 1. กล่องข้อความแจ้งเตือนสีม่วงอ่อน (Info Box) ตามรูปเป๊ะ ๆ -->
                  <div class="d-flex align-items-center p-3 rounded-4 mb-4 border" 
                      style="background-color: #f3e8ff; border-color: #e9d5ff !important; color: #6b21a8;">
                    <span class="material-icons me-2" style="font-size: 20px; color: #7c3aed;">info_outline</span>
                    <span class="fw-medium" style="font-size: 14.5px; letter-spacing: 0.2px;">
                      เฉพาะ SHOP_MANAGER เท่านั้นที่สามารถตั้ง PIN ได้
                    </span>
                  </div>

                  <!-- 2. ช่องกรอกรหัส PIN (เปลี่ยนเป็น 4 หลัก และเซ็ต Input ให้อยู่กึ่งกลางแสดงผลเป็นจุดกลม) -->
                  <input 
                    type="password" 
                    v-model="setPinForm.pin" 
                    maxlength="4" 
                    pattern="\d*" 
                    inputmode="numeric" 
                    @keypress="onlyNumber"
                    class="form-control form-control-lg bg-light border py-3 text-center rounded-4 shadow-none custom-pin-dots" 
                    placeholder="• • • •" 
                    style="font-size: 22px; letter-spacing: 12px; border-color: #e2e8f0 !important;" 
                    required
                  >
              </div>

              <!-- MODAL FOOTER CONTROLS: ปรับสีปุ่มและระยะชิดขวาตามแบบ UI ของคุณ -->
              <div class="modal-footer border-top-0 px-4 pb-4 pt-2 d-flex justify-content-end align-items-center gap-4 bg-white">
                <!-- ปุ่ม Cancel สีเทาเรียบง่ายแบบตัวหนังสือ -->
                <button type="button" class="btn btn-link text-secondary text-decoration-none shadow-none fw-semibold p-0" 
                        data-bs-dismiss="modal" style="font-size: 16px; color: #64748b !important;">
                  Cancel
                </button>
                <!-- ปุ่มหลัก Set PIN ทรงมนสีม่วงตามรูป -->
                <button 
                  type="button" 
                  class="btn btn-primary btn-lg text-white px-4 py-2.5 shadow-none fw-semibold rounded-4" 
                  style="min-width: 140px; background-color: #7c3aed; border: none; font-size: 16px; box-shadow: 0 4px 6px -1px rgba(124, 58, 237, 0.2);"
                  :disabled="!setPinForm.pin || setPinForm.pin.length !== 4" @click="handleSetPin"
                >
                  Set PIN
                </button>
              </div>

            </div>
          </div>
        </div>


        <div id="removeShopModal" class="modal fade" tabindex="-1" aria-labelledby="removeShopModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 460px;">
            <div class="modal-content border-0 shadow-lg p-4 text-center" style="border-radius: 16px;">
              
              <!-- MODAL BODY: จัดตำแหน่งให้อยู่ตรงกลางทั้งหมดสไตล์คลีนแบบเดียวกับ Delete User -->
              <div class="modal-body p-0">
                
                <!-- ไอคอนรูปถังขยะหรือไอคอนลบสีแดงในวงกลมสีแดงอ่อน -->
                <div class="d-flex align-items-center justify-content-center mx-auto mb-3" 
                    style="width: 70px; height: 70px; background-color: #ffe8e8; border-radius: 50%;">
                  <span class="material-icons text-danger" style="font-size: 32px;">delete_outline</span>
                </div>

                <!-- หัวข้อลบสิทธิ์สาขา -->
                <h4 class="fw-bold mb-2" style="color: #2d3748; font-size: 22px;">Remove Shop</h4>
                
                <!-- ข้อความแจ้งเตือนดึงค่าตามพนักงานและสาขาที่เลือกจริง -->
                <p class="text-secondary mb-4 px-2" style="font-size: 15px; color: #718096 !important; line-height: 1.5;">
                  คุณต้องการลบ ผู้ใช้งาน <span class="fw-semibold" style="color: #4a5568;">{{ removeShopForm.userNameTh }}</span> <br>
                  ออกจากสาขา <span class="fw-bold text-dark">{{ removeShopForm.shopName }} [{{ removeShopForm.shopCode }}]</span> <br>
                  ใช่หรือไม่?
                </p>

                <!-- กลุ่มปุ่มกดยืนยันการลบ จัดแบบแนวนอนขนานคู่กันตามธีมหลัก -->
                <div class="d-flex justify-content-center gap-3">
                  <button type="button" class="btn btn-light text-secondary fw-semibold border-0 px-4 py-2 rounded-3 shadow-none" 
                          data-bs-dismiss="modal" style="background-color: #f1f3f9; min-width: 110px; font-size: 14px;">
                    Cancel
                  </button>
                  
                  <button type="button" class="btn btn-danger fw-semibold px-4 py-2 rounded-3 shadow-none" 
                          style="background-color: #e53e3e; border: none; min-width: 110px; font-size: 14px;"
                          @click="handleRemoveShopSubmit">
                    Remove
                  </button>
                </div>

              </div>

            </div>
          </div>
        </div>


        <!-- Assign Shop Modal -->
        <div id="assignShopModal" class="modal fade" tabindex="-1" aria-labelledby="assignShopModalLabel" aria-hidden="true">
          <!-- ปรับความกว้างให้พอดี 700px สวยงาม ไม่กว้างเกินไป -->
          <div class="modal-dialog modal-dialog-centered" style="max-width: 700px;">
            <div class="modal-content border-0 shadow-lg overflow-hidden" style="border-radius: 12px;">
              
              <!-- MODAL HEADER -->
              <div class="p-4 text-white" style="background-color: #00b074;">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 class="modal-title fw-bold m-0" style="font-size: 20px; letter-spacing: 0.3px;color: #ffffff !important;">Assign to Shop</h4>
                    <p class="text-white opacity-85 small mb-0 mt-1" v-if="assignSingleForm.nameTh" style="font-size: 13.5px;">
                      {{ assignSingleForm.nameTh }} ({{ assignSingleForm.employeeNumber }})
                    </p>
                  </div>
                  <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
              </div>

              <!-- MODAL BODY -->
              <div class="modal-body px-4 py-3 bg-white" style="max-height: 70vh; overflow-y: auto;">
                  <div class="row g-3">
                    <!-- ส่วนเลือก Shop -->
                    <div class="col-md-6">
                      <label class="form-label small text-secondary mb-1" style="font-size: 13px; color: #4a5568 !important;">Shop</label>
                      <select v-model="assignSingleForm.shopUid" class="form-select form-select-sm rounded shadow-none" style="padding: 0.4rem 0.75rem; font-size: 13.5px; border-color: #cbd5e1 !important;" required>
                        <option value="" disabled selected>— Select shop —</option>
                        <option v-for="s in shopList" :key="s.uid" :value="String(s.uid).trim()"
                          :disabled="String(s.uid).trim() !== key.uid">
                          {{ s.code }} - {{ s.nameTh }}
                        </option>
                      </select>
                    </div>
                    
                    <!-- ส่วนเลือก Business Role -->
                    <div class="col-md-6">
                      <label class="form-label small text-secondary mb-1" style="font-size: 13px; color: #4a5568 !important;">Business Role</label>
                      <select v-model="assignSingleForm.businessRole" class="form-select form-select-sm rounded shadow-none" style="padding: 0.4rem 0.75rem; font-size: 13.5px; border-color: #cbd5e1 !important;" required>
                        <option value="" disabled selected>— Select business role —</option>
                        <option 
                          v-for="role in roleList" 
                          :key="role" 
                          :value="role.businessRole"
                          :disabled="role.businessRole === 'GROUP_ADMIN'"
                        >
                          {{ role.businessRole }}
                        </option>
                      </select>
                    </div>

                  </div>
              </div>

              <!-- MODAL FOOTER CONTROLS -->
              <div class="modal-footer border-top-0 px-4 pb-4 pt-1 d-flex justify-content-end align-items-center gap-3 bg-white">
                <button type="button" class="btn btn-link text-secondary text-decoration-none shadow-none fw-bold p-0" data-bs-dismiss="modal" style="font-size: 13.5px; letter-spacing: 0.3px;">
                  CANCEL
                </button>
                <button 
                  type="submit" 
                  class="btn btn-success btn-sm text-white px-3 py-1.5 shadow-none fw-bold rounded-2" 
                  style="min-width: 95px; background-color: #00b074; border: none; font-size: 13.5px; letter-spacing: 0.3px;"
                  :disabled="isFormAssignShopInvalid" @click="handleAssignShop">
                  {{ isEditMode ? 'UPDATE' : 'ASSIGN' }}
                </button>
              </div>

            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</template>


<script setup>
/* eslint-disable no-unused-vars */
import { reactive, computed, ref, inject } from "vue";
import { useI18n } from "vue-i18n";
import Modal from 'bootstrap/js/dist/modal';
import moment from 'moment'
import ExampleFive from "@/examples/ExampleOne";
import ProgressSpinner from 'primevue/progressspinner';
import InputNumber from 'primevue/inputnumber';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import { useRouter } from 'vue-router'


import { useSecUsersStore } from '@/stores/secusers'
import { useSecUsersRoleStore } from '@/stores/secusersrole'
import { useSecShopRoleStore } from '@/stores/secshoprole'

const { t } = useI18n();
const swal = inject("$swal");

const storesec_u = useSecUsersStore()
const storesec_ur = useSecUsersRoleStore()
const storesec_sr = useSecShopRoleStore()

const shopList = ref([]);
const roleList = ref([]);
const router = useRouter()

const GOLDEN_ANGLE = 137.508
const shopColor  = (uid) => {
  const idx = shopList.value.findIndex(s => s.uid === uid)
  const i   = idx < 0 ? 0 : idx
  const hue = (i * GOLDEN_ANGLE) % 360
  const L   = i % 2 === 0 ? 0.50 : 0.54
  return `oklch(${L} 0.13 ${hue.toFixed(1)})`
}
const shopBg     = (uid) => `color-mix(in oklch, ${shopColor(uid)} 13%, white)`
const shopBorder = (uid) => `color-mix(in oklch, ${shopColor(uid)} 35%, white)`
const listdata = ref([]);
const empNum = ref('');

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(10);
const totalRows_s = ref();

const users = ref([
  { uid: 'u1',  employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน', nameEn: 'BDM Admin',    email: 'bdmnadmin01@nvtx.tech', userLevel: 'admin',
    shops: [
      { shopUid: '564650065004595065', role: 'GROUP_ADMIN' },
      { shopUid: '564650609597220734', role: 'GROUP_ADMIN' },
      { shopUid: '590532343199164463', role: 'GROUP_ADMIN' },
      { shopUid: '590532688809814064', role: 'GROUP_ADMIN' },
      { shopUid: '628611923313744384', role: 'GROUP_ADMIN' },
    ] },
  { uid: 'u2',  employeeNumber: 'NW0001', nameTh: 'นาค1 นิวาส',   nameEn: 'Nak1 Nivas',   email: 'nwuser01@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '564650065004595065', role: 'SHOP_MANAGER' }] },
  { uid: 'u3',  employeeNumber: 'NW0002', nameTh: 'นาค2 นิวาส',   nameEn: 'Nak2 Nivas',   email: 'nwuser02@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '564650065004595065', role: 'SHOP_MANAGER' }] },
  { uid: 'u4',  employeeNumber: 'NW0003', nameTh: 'นาค3 นิวาส',   nameEn: 'Nak3 Nivas',   email: 'nwuser03@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '564650065004595065', role: 'THAI_CLERK' }] },
  { uid: 'u5',  employeeNumber: 'NW0005', nameTh: 'นาค5 นิวาส',   nameEn: 'Nak5 Nivas',   email: 'nwuser05@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '564650065004595065', role: 'CHINESE_CLERK' }] },
  { uid: 'u6',  employeeNumber: 'NW0007', nameTh: 'นาค7 นิวาส',   nameEn: 'Nak7 Nivas',   email: 'nwuser07@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '564650065004595065', role: 'VAULT_KEEPER' }] },
  { uid: 'u7',  employeeNumber: 'KL0001', nameTh: 'คลอง1 หลวง',   nameEn: 'Klong1 Luang', email: 'kluser01@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '564650609597220734', role: 'SHOP_MANAGER' }] },
  { uid: 'u8',  employeeNumber: 'TR0001', nameTh: 'TR1',            nameEn: 'TR1',           email: 'truser01@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '590532343199164463', role: 'SHOP_MANAGER' }] },
  { uid: 'u9',  employeeNumber: 'BM0001', nameTh: 'BM1',            nameEn: 'BM1',           email: 'bmuser01@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '590532688809814064', role: 'SHOP_MANAGER' }] },
  { uid: 'u10', employeeNumber: 'NV0001', nameTh: 'NV1',            nameEn: 'NV1',           email: 'nvuser01@nvtx.tech',   userLevel: 'user', shops: [{ shopUid: '628611923313744384', role: 'SHOP_MANAGER' }] },
  { uid: 'u11', employeeNumber: 'NW0009', nameTh: 'วิทิต',          nameEn: 'how',           email: 'how@nvtx.tech',        userLevel: 'user',
    shops: [{ shopUid: '564650065004595065', role: 'SHOP_MANAGER' }, { shopUid: '564650609597220734', role: 'SHOP_MANAGER' }] },
  { uid: 'u12', employeeNumber: 'NV0002', nameTh: 'NV2',            nameEn: 'NV2',           email: 'nvuser02@nvtx.tech',   userLevel: 'user', shops: [] },
])

const showPassword = ref(false)
const showConfirmPassword = ref(false)

const showResetPassword = ref(false)
const showResetConfirmPassword = ref(false)

// โครงสร้างข้อมูลฟอร์ม
const form = ref({
  groupUid: '', // ใส่ค่ารหัส Group ของคุณ
  employeeNumber: 'BDM',     // ค่าเริ่มต้นล็อกด้วย BDM
  userLevel: 'user',         // ล็อกสิทธิ์ผู้ใช้งานเป็น user เสมอ
  nameTh: '',
  nameEn: '',
  email: '',
  username: '',
  password: '',
  confirmPassword: ''
})

const editForm = ref({
  uid: '',
  groupUid: '',
  username: '',
  employeeNumber: '',
  nameTh: '',
  nameEn: '',
  email: '',
  userLevel: 'user',
  accountStatus: '',
  version: 0
})

const resetPwdForm = ref({
  uid: '',
  groupUid: '', 
  employeeNumber: '',
  nameTh: '',
  password: '',
  confirmPassword: ''
})

const deleteForm = ref({
  uid: '',
  employeeNumber: '',
  nameTh: ''
})

const setPinForm = ref({
  uid: '',
  userUid: '',
  groupUid: '',
  shopUid: '',
  shopCode: '',
  employeeNumber: '',
  nameTh: '',
  pin: '',
  confirmPin: ''
})

const removeShopForm = ref({
  uid: '',
  userUid: '',
  shopUid: '',
  shopCode: '',
  shopName: '',
  userNameTh: ''
})

const assignSingleForm = ref({
  uid: '',
  userUid: '',
  groupUid: '',
  shopUid: '',
  userLevel: 'user',
  businessRole: '',
  employeeNumber: '',
  nameTh: '',
  version: 0
})

const isEditMode = ref(false)

let typingTimer = null


// ฟังก์ชันจัดการรับค่าและแปลงรูปแบบเวลาอัตโนมัติ (เช่น พิมพ์ 1200 กลายเป็น 12:00)


const cancel = computed(() => t("buttons.canc"));
const confirm = computed(() => t("buttons.conf"));
const save = computed(() => t("buttons.save"));
const btnSearch = computed(() => t("buttons.sear"));
const btnAddNew = computed(() => t("content.amnaddnew"));

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const onClickHandler = (page) => {
  updatePagination()
};


const loadRoleList = async () => {
  let data = "";
  data = {
    shopUid: key.uid,
    businessRole:''
  };
  const payload = data;
  const response = await storesec_sr.shopRoleListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        roleList.value = response.data.data.list
      }
    }
  }
}

const infoshop = async (val) => {
  shopList.value = []
  if (localStorage.getItem("shoplist") !== null) {
    shopList.value = JSON.parse(localStorage.getItem("shoplist"));
    await loadRoleList()
  }
}


infoshop()


// ใช้เก็บรหัสอ้างอิงแถวที่กำลังเปิดค้างไว้
const expandedRows    = ref(null)
const expandedShops   = ref({})

// ตัวแปรสำหรับเก็บข้อมูลรายย่อยของแถวที่คลิกเปิดเปิด
const expandedRowData = ref(null)

const toggleRow = async (item) => {
  // รองรับกรณีระบุค่า item เข้ามาเป็น Object หรือเป็น String ID ตรงๆ
  const userUid = item && typeof item === 'object' ? item.uid : item

  if (expandedRows.value === userUid) {
    // ➔ ถ้าคลิกซ้ำที่แถวเดิมที่เปิดอยู่ -> ให้ปิดลงและล้างข้อมูล
    expandedRows.value  = null
  expandedShops.value = {}
    expandedRowData.value = null
  } else {
    // ➔ ถ้าคลิกแถวใหม่ -> สั่งเปิดแถวนั้นก่อนเพื่อความเร็วในการตอบสนอง UI
    expandedRows.value = userUid
    expandedRowData.value = null // ✨ ล้างค่าเก่าออกเป็น null ทันที เพื่อให้หน้าจอแสดง "กำลังโหลดข้อมูล..."
    
    try {
      // 🔄 เรียกฟังก์ชันโหลดข้อมูลสาขาของพนักงานคนนี้ตามสเปกระบบเดิมของคุณ
      if (typeof refreshTableData === 'function' && userUid) {
        await refreshTableData(userUid) // สมมติว่าฟังก์ชันนี้จะดึงข้อมูลรายละเอียดของพนักงานมาแสดงในแถวที่เปิด
      }
    } catch (error) {
      console.error('ดึงข้อมูลรายละเอียดพนักงานไม่สำเร็จ:', error)
      // ✨ หาก API พัง ให้เปลี่ยนเป็น [] เพื่อหยุดการหมุนโหลด แล้วแสดงป้าย "ไม่พบข้อมูล" แทน
      expandedRowData.value = [] 
    }
  }
}

// 3. ปรับปรุงฟังก์ชันเช็กสถานะการเปิดแถว
const isExpanded = (id) => {
  // คืนค่าเป็น true เฉพาะแถวที่มี ID ตรงกับตัวแปรปัจจุบันเท่านั้น
  return expandedRows.value === id
}

const isDisabledUser = (row) => {
  return row?.userLevel === 'admin' || row?.email?.includes('platform') || row?.email?.includes('@novatecx.com')
};


async function findShops(item, process) {
  const roleRes = await storesec_ur.usersRoleListFetch({
    index: 0,
    size: 100,
    userLevel: '',
    shopUid: '',
    userUid: item.uid,
    businessRole: '',
  })

  if (roleRes?.status === 200 && roleRes.data.rtnDesc === 'success') {
    const roles = roleRes.data.data.list

    // 1. เคสที่ข้อมูลสิทธิ์ร้านค้าว่างเปล่า (ไม่มีข้อมูลการมอบหมายเลย)
    if (!roles || roles.length === 0) {
      if (process === 'delete') {
        setDeleteUser(item) // ยอมให้ลบเฉพาะตอนที่สิทธิ์ว่างเปล่าเท่านั้น
      } else {
        swal("ไม่พบข้อมูลการมอบหมายสาขา", "", "warning")
      }
      return // ออกจากฟังก์ชันทันที
    }

    // 2. เคสลบข้อมูล (delete) แต่ตรวจสอบแล้วว่ายังมีสิทธิ์ร้านค้าค้างอยู่ (ไม่ว่างเปล่า)
    if (process === 'delete') {
      swal("ไม่สามารถลบผู้ใช้งานได้ เนื่องจากยังมีข้อมูลการมอบหมายสาขาค้างอยู่", "", "warning")
      return
    }

    // 3. เคสย้ายหน้าตารางงาน (schedule)
    if (process === 'schedule') {
       router.push({ name: 'UserSchedule', query: { uid: item.uid } })
      return 
    }

    // 4. เคสแก้ไขข้อมูล (edit) หรือ รีเซ็ตรหัสผ่าน (reset)
    if (process === 'edit' || process === 'reset') {
      if (roles.some(shop => shop.shopUid === key.uid)) {
        if (process === 'edit') {
          setedit(item)
        } else if (process === 'reset') {
          setResetPassword(item)
        }
      } else {
         swal("แก้ไขข้อมูลได้เฉพาะที่อยู่สาขา " + key.code, "", "warning")
      }
      return
    }
  }
}


const loadDataApi = async (val) => {
  let data = "";
  expandedRows.value  = null
  expandedShops.value = {}
  expandedRowData.value = null
  if (currentPage.value !== 1) {
    if (listdata.value.length === 1 && val === 'del') {
      currentPage.value = currentPage.value - 1
    }
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    employeeNumber: empNum.value.trim(),
  };

  const payload = data;
  const response = await storesec_u.usersListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listdata.value = response.data.data.list
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value);
      }
    }
  }
}

async function updatePagination() {
  let data = "";
  listdata.value = []
  expandedRows.value  = null
  expandedShops.value = {}
  expandedRowData.value = null

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    employeeNumber: empNum.value.trim(),
  };

  const payload = data;
  const response = await storesec_u.usersListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listdata.value = response.data.data.list
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value);
      }
    }
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

// ฟังก์ชันแจกจ่ายสีพื้นหลังและสีอักษรให้สวยงาม มีมิติตามสากลแบบตรงเฉดสี UI ล่าสุด
const getRoleBadgeStyle = (roleName) => {
  switch (roleName) {
    case 'GROUP_ADMIN':
      return { backgroundColor: '#ffe8e8', color: '#e53e3e' } // สีแดง
    case 'SHOP_MANAGER':
      return { backgroundColor: '#e8ebff', color: '#3f51b5' } // สีน้ำเงิน/ม่วง
    case 'THAI_CLERK':
      return { backgroundColor: '#dcfce7', color: '#15803d' } // สีเขียว
    case 'CHINESE_CLERK':
      return { backgroundColor: '#fef9c3', color: '#a16207' } // สีเหลือง/ส้มทอง
    case 'VAULT_KEEPER':
      return { backgroundColor: '#f3e8ff', color: '#7c3aed' } // สีม่วง
    default:
      return { backgroundColor: '#f1f5f9', color: '#475569' } // สีเทา
  }
}

const onlyNumber = (event) => {
  // อนุญาตเฉพาะคีย์ที่เป็นรหัสตัวเลข 0-9 เท่านั้น
  const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  if (!keysAllowed.includes(event.key)) {
    event.preventDefault() // สั่งทำลายคำสั่งพิมพ์อักษรทิ้งไปทันที
  }
}

async function setadd() {

  // 1. เคลียร์ค่าตัวแปรในฟอร์ม และเซ็ตค่า Default ล็อกตาม Requirements ใหม่
  form.value = {
    groupUid: key.groupUid, // ดึงค่า groupUid จากตัวแปร key ที่เก็บไว้ใน localStorage
    employeeNumber: 'BDM', // 🟢 ล็อกให้ขึ้นต้นด้วย BDM ค้างไว้ให้ทันทีเมื่อกดเปิดฟอร์ม
    userLevel: 'user',     // ล็อกระดับผู้ใช้งานเป็น user เสมอ
    nameTh: '',
    nameEn: '',
    email: '',
    username: '',
    password: '',
    confirmPassword: ''    // 🟢 เอา assignedShops ออกเนื่องจากฟอร์มเหลือ 1 Step คลีนๆ แล้ว
  };

  // 2. เคลียร์สถานะรูปตา (Toggle Password) ให้กลับไปซ่อนรหัสผ่านตามเดิมทุกครั้งที่เปิดใหม่
  if (typeof showPassword.value !== 'undefined') showPassword.value = false;
  if (typeof showConfirmPassword.value !== 'undefined') showConfirmPassword.value = false;

  // 3. เปิดโมดัลเพิ่มผู้ใช้งานใหม่ (Bootstrap 5 Instance)
  openModalElement('newUsersModal')
}

// 2. ฟังก์ชันตรวจสอบล็อกไม่ให้พนักงานเผลอลบอักษรนำหน้า "BDM" ออกขณะพิมพ์
const validateEmployeeNumber = () => {
  if (!form.value.employeeNumber.toUpperCase().startsWith('BDM')) {
    form.value.employeeNumber = 'BDM'
  }
}

// 3. ฟังก์ชันเติมพ่วงท้ายโดเมนองค์กร @ibuddy.biz ทันทีเมื่อผู้ใช้เอาเมาส์ออกจากกล่องพิมพ์ (Blur)
// const fixEmailSuffix = () => {
//   let emailVal = form.value.email.trim()
//   if (!emailVal) return

//   const defaultSuffix = '@ibuddy.biz'

//   if (!emailVal.endsWith(defaultSuffix)) {
//     // แยกเอาเฉพาะข้อความก่อนเครื่องหมาย @ (เช่น พิมพ์ test@gmail.com จะตัดเอาแค่ test)
//     if (emailVal.includes('@')) {
//       emailVal = emailVal.split('@')[0] // ✅ แก้ไขจากเดิมที่เป็น Array ให้เป็น String ตัวแรกแล้ว
//     }

//     const finalizedEmail = emailVal + defaultSuffix

//     // อัปเดตทั้งสองค่าพร้อมกันเพื่อป้องกันระบบ Reactive บั๊ก
//     form.value.email = finalizedEmail
//     form.value.username = finalizedEmail
//   }
// }

// ฟังก์ชันทำงานตอนกำลังพิมพ์ (@input="handleEmailInput")
const handleEmailInput = () => {
  const emailVal = form.value.email.trim()
  if (!emailVal) {
    form.value.username = ''
    return
  }

  // ซิงค์ค่าและตัดเอาเฉพาะ Username ด้านหน้าส่งไปช่อง username แบบ real-time
  if (emailVal.includes('@')) {
    form.value.username = emailVal.split('@')[0]
  } else {
    form.value.username = emailVal
  }
}

// ฟังก์ชันทำงานตอนละสายตาจากช่องกรอก (@blur="fixEmailSuffix")
const fixEmailSuffix = () => {
  let emailVal = form.value.email.trim()
  if (!emailVal || errors.value.email) return // ถ้า computed ฟ้องว่าเป็นตัวแดง (Invalid) จะไม่เติมโดเมนให้

  let usernamePart = emailVal
  if (emailVal.includes('@')) {
    usernamePart = emailVal.split('@')[0]
  }

  // เติมพ่วงท้ายเมื่อโครงสร้างจุดผ่านการทดสอบ computed เรียบร้อยแล้วเท่านั้น
  const defaultSuffix = '@ibuddy.biz'
  form.value.email = usernamePart + defaultSuffix
  form.value.username = usernamePart
}

// 4. ตรรกะดักซ่อน/แสดงข้อความเตือนของช่องยืนยันรหัสผ่าน (แสดงต่อเมื่อเริ่มกรอกช่องสองเท่านั้น)
const shouldShowConfirmError = computed(() => {
  // 🟢 หากช่อง Confirm Password ยังว่างเปล่าอยู่ จะไม่แสดงคำเตือนสีแดงเด็ดขาด
  if (!form.value.confirmPassword) return false
  
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
  return form.value.password !== form.value.confirmPassword || !passwordRegex.test(form.value.password)
})

// 5. บล็อกการตรวจสอบประเมินความผิดพลาดแบบ Real-time (ผูกแสดงผล Label ด้านบนของ Input)
const errors = computed(() => {
  // ✅ โค้ดเดิมของคุณ
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).+$/

  // 📝 ตรวจสอบเงื่อนไขอีเมลองค์กรตัวแดงแบบ Real-time
  let isEmailInvalid = true
  const emailVal = form.value.email ? form.value.email.trim() : ''

  if (emailVal) {
    // แยกเอาเฉพาะข้อความก่อนเครื่องหมาย @ ออกมาเช็ค
    let usernamePart = emailVal
    if (emailVal.includes('@')) {
      usernamePart = emailVal.split('@')[0]
    }

    // นับจำนวนจุดใน username ตัวหน้า
    const dotCount = (usernamePart.match(/\./g) || []).length
    
    // เงื่อนไข: ต้องมี 1 จุด, ห้ามอยู่หน้าสุด/หลังสุด
    const hasCorrectDot = dotCount === 1 && !usernamePart.startsWith('.') && !usernamePart.endsWith('.')

    // ตรวจสอบโดเมน (ถ้ามีการพิมพ์ @ เข้ามาแล้ว ต้องลงท้ายด้วย @ibuddy.biz เท่านั้น)
    let isDomainValid = true
    if (emailVal.includes('@') && !emailVal.endsWith('@ibuddy.biz')) {
      isDomainValid = false
    }

    // ถ้าผ่านหมดทุกอย่าง ถือว่าป้อนข้อมูลอีเมลถูกต้อง (isEmailInvalid = false)
    if (hasCorrectDot && isDomainValid) {
      isEmailInvalid = false
    }
  }

  return {
    employeeNumber: form.value.employeeNumber.trim().length <= 3, 
    nameTh: form.value.nameTh.trim() === '',                     
    email: isEmailInvalid, // 👈 ส่งค่า Boolean กลับไปควบคุมตัวแดงที่หน้า UI ทันที
    password: form.value.password ? !passwordRegex.test(form.value.password) : true, 
    confirmPassword: shouldShowConfirmError.value                
  }
})

// 6. ตรวจจับสถานะความเรียบร้อยรวม เพื่อล็อกปุ่ม CREATE (Disabled) จนกว่าฟอร์มจะสมบูรณ์
const isFormInvalid = computed(() => {
  return Object.values(errors.value).some(status => status === true)
})

async function handleAddNewUser() {
  let data = "";
  data = {
    groupUid: form.value.groupUid,
    username: form.value.username,
    employeeNumber: form.value.employeeNumber,
    nameTh: form.value.nameTh,
    nameEn: form.value.nameEn,
    email: form.value.email,
    userLevel: form.value.userLevel,
    accountStatus: 'ACTIVE',
    version: 0
  };
  const payload = data;

  const response = await storesec_u.usersAddFetch(payload)
  // console.log('del res : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        closeModalElement('newUsersModal')
        await setPassword(response.data.data)
      } else {
        swal("บันทึกข้อมูลผู้ใช้งานไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function setPassword(item) {
  let data = "";
  data = {
    uid: item.uid, // ดึง uid ที่ได้จากการสร้างผู้ใช้ใหม่มาใช้ต่อในขั้นตอนตั้งรหัสผ่าน
    groupUid: form.value.groupUid,
    password: form.value.password
  };
  const payload = data;
  const response = await storesec_u.usersSetPasswordFetch(payload)
  // console.log('setPassword response:', JSON.stringify(response?.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi('add')
      } else {
        swal("บันทึกรหัสผ่านไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    } else {
      swal("บันทึกรหัสผ่านไม่สำเร็จ", `HTTP ${response.status}`, "error");
    }
  }
}



// ฟังก์ชันทำงานตอนกำลังพิมพ์อินพุตแก้ไข (@input)
const handleEditEmailInput = () => {
  const emailVal = editForm.value.email.trim()
  if (!emailVal) {
    editForm.value.username = ''
    return
  }

  // ซิงค์ค่าและตัดเอาเฉพาะ Username ด้านหน้าเครื่องหมาย @ ไปอัปเดตช่อง username
  if (emailVal.includes('@')) {
    editForm.value.username = emailVal.split('@')[0]
  } else {
    editForm.value.username = emailVal
  }
}

// ฟังก์ชันทำงานตอนละสายตาจากกล่องแก้ไข (@blur)
const fixEditEmailSuffix = () => {
  let emailVal = editForm.value.email.trim()
  // ถ้าช่องว่าง หรือระบบตรวจจับจาก computed แล้วว่าเป็นตัวแดง (editErrors.email === true) จะไม่ยอมเติมต่อท้าย
  if (!emailVal || editErrors.value.email) return 

  let usernamePart = emailVal
  if (emailVal.includes('@')) {
    usernamePart = emailVal.split('@')[0]
  }

  // ประกอบฟอร์มให้สมบูรณ์เมื่อผ่านการตรวจเช็คจุดจาก computed เรียบร้อยแล้ว
  const defaultSuffix = '@ibuddy.biz'
  editForm.value.email = usernamePart + defaultSuffix
  editForm.value.username = usernamePart
}

// 2. ตรรกะประเมินข้อผิดพลาดสำหรับหน้าต่างแก้ไข (ลบส่วนเช็คพนักงานออกเนื่องจากโดนล็อก readonly ไปแล้ว)
const editErrors = computed(() => {
  // 📝 ตรวจสอบเงื่อนไขอีเมลองค์กรตัวแดงแบบ Real-time สำหรับโหมดแก้ไข
  let isEmailInvalid = true
  const emailVal = editForm.value.email ? editForm.value.email.trim() : ''

  if (emailVal) {
    // แยกเอาเฉพาะข้อความก่อนเครื่องหมาย @ ออกมาเช็ค
    let usernamePart = emailVal
    if (emailVal.includes('@')) {
      usernamePart = emailVal.split('@')[0]
    }

    // นับจำนวนจุดใน username ตัวหน้า
    const dotCount = (usernamePart.match(/\./g) || []).length
    
    // เงื่อนไข: ต้องมี 1 จุดถ้วน และจุดห้ามอยู่ตัวแรกหรือตัวสุดท้าย
    const hasCorrectDot = dotCount === 1 && !usernamePart.startsWith('.') && !usernamePart.endsWith('.')

    // ตรวจสอบโดเมน (ถ้ามีการพิมพ์ @ เข้ามาแล้ว ต้องลงท้ายด้วย @ibuddy.biz เท่านั้น)
    let isDomainValid = true
    if (emailVal.includes('@') && !emailVal.endsWith('@ibuddy.biz')) {
      isDomainValid = false
    }

    // ถ้าผ่านหมดทุกอย่าง ถือว่าป้อนข้อมูลอีเมลถูกต้อง (isEmailInvalid = false)
    if (hasCorrectDot && isDomainValid) {
      isEmailInvalid = false
    }
  }

  return {
    nameTh: editForm.value.nameTh.trim() === '',
    email: isEmailInvalid // 👈 ปรับปรุงใหม่ให้เช็คจุดและล็อกโดเมนทันทีแบบ Real-time
  }
})

// 3. สั่งล็อกปุ่ม SAVE (Disabled) ทันทีหากอีเมลไม่ถูกรูปแบบ หรือพิมพ์ชื่อไทยว่างเปล่า
const isEditFormInvalid = computed(() => {
  return Object.values(editErrors.value).some(status => status === true)
})

// 2. ปรับฟังก์ชัน setedit ให้เก็บค่าสถานะและข้อมูลเสริมทุกตัวจาก row มาพักไว้
async function setedit(row) {
  editForm.value = {
    uid: row.uid || '',
    groupUid: row.groupUid || '',
    username: row.username || '',
    employeeNumber: row.employeeNumber || '',
    nameTh: row.nameTh || '',
    nameEn: row.nameEn || '',
    email: row.email || '',
    userLevel: row.userLevel || 'user',
    accountStatus: row.accountStatus || 'ACTIVE',
    version: row.version !== undefined ? row.version : 0
  }
  openModalElement('editUserModal') 
}

// 3. ฟังก์ชันอัปเดตเมื่อกดปุ่ม Save จะได้โครงสร้าง `body` ตรงตามรูปภาพ
async function handleUpdateUser(){
  // สร้างตัวแปร body แมปค่าตรงตามที่หลังบ้านต้องการเป๊ะ ๆ
  const body = {
    uid: editForm.value.uid,
    groupUid: editForm.value.groupUid,
    username: editForm.value.username,
    employeeNumber: editForm.value.employeeNumber,
    nameTh: editForm.value.nameTh,
    nameEn: editForm.value.nameEn,
    email: editForm.value.email,
    userLevel: editForm.value.userLevel,
    accountStatus: editForm.value.accountStatus,
    version: editForm.value.version
  }
  
  const response = await storesec_u.usersUpdateFetch(body)
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        closeModalElement('editUserModal')
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi('update')
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


function setResetPassword(row) {
  resetPwdForm.value = {
    uid: row.uid || '',
    groupUid: row.groupUid || '', // ดึง groupUid ติดตัวมาพักรอไว้ใช้งาน
    employeeNumber: row.employeeNumber || '',
    nameTh: row.nameTh || '',
    password: '',        // รีเซ็ตช่องว่างพาสเวิร์ดใหม่ทุกครั้งที่กดเปิด
    confirmPassword: ''  // รีเซ็ตช่องว่างการยืนยันพาสเวิร์ด
  }

  openModalElement('resetPasswordModal')
}

// ตรรกะตรวจสอบการพิมพ์ไม่ตรงกันของช่องยืนยันรหัสผ่าน
const shouldShowResetConfirmError = computed(() => {
  // 🟢 ดึงข้อมูลจากก้อนออบเจกต์รีเซ็ตโดยตรง
  if (!resetPwdForm.value.confirmPassword) return false
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
  return resetPwdForm.value.password !== resetPwdForm.value.confirmPassword || !passwordRegex.test(resetPwdForm.value.password)
})

// ตัวแปรตรวจสอบเงื่อนไขความปลอดภัยหลักเพื่อส่งคลาสระบายสีขอบแดง
const resetErrors = computed(() => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
  return {
    password: resetPwdForm.value.password ? !passwordRegex.test(resetPwdForm.value.password) : true,
    confirmPassword: shouldShowResetConfirmError.value
  }
})

// สั่งล็อกปิดปุ่มเมื่อข้อมูลในฟอร์มพิมพ์ผิดเกณฑ์
const isResetFormInvalid = computed(() => {
  return Object.values(resetErrors.value).some(status => status === true)
})


const handleResetPassword = async () => {
  // ตรวจสอบเช็กความตรงกันของรหัสผ่านทั้งสองช่องกรอก
  if (resetPwdForm.value.password !== resetPwdForm.value.confirmPassword) {
    alert('รหัสผ่านและการยืนยันรหัสผ่านไม่ตรงกัน')
    return
  }

  // จัดการขึ้นโครง payload ให้ถูกต้องครบถ้วนตามภาพคำขอของ API
  const payload = {
    uid: resetPwdForm.value.uid,
    groupUid: resetPwdForm.value.groupUid,
    password: resetPwdForm.value.password
  }

  try {
    const response = await storesec_u.usersSetPasswordFetch(payload);
    // console.log('del res : ' + JSON.stringify(response.data));
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          closeModalElement('resetPasswordModal')
          swal("บันทึกสำเร็จ", "", "success");
        } else {
          swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
        }
      }
    }

  } catch (error) {
    console.error('เกิดข้อผิดพลาดไม่สามารถบันทึกรหัสผ่านได้:', error)
    alert('เกิดข้อผิดพลาดในการตั้งค่ารหัสผ่านใหม่ กรุณาลองอีกครั้ง')
  }
}

// 2. ฟังก์ชันจับข้อมูลแถวที่คลิก ดึงค่าชื่อ-รหัสพนักงานมาพักไว้ แล้วเปิด Modal ยืนยัน
function setDeleteUser(row) {
  // บล็อกสิทธิ์ความปลอดภัยล่วงหน้า หากผู้ใช้งานยังมีร้านค้าสังกัดอยู่ (ความกว้างของอาเรย์ shops > 0) จะไม่ให้ทำรายการลบ
  // if (row.shops && row.shops.length > 0) return

  deleteForm.value = {
    uid: row.uid || '',
    employeeNumber: row.employeeNumber || '',
    nameTh: row.nameTh || ''
  }

  openModalElement('deleteUserModal')
}

async function handleDeleteUser() {
  let data = "";
  data = {
     uid: deleteForm.value.uid
  };
  const payload = data;
  // console.log('del payload : ' + JSON.stringify(payload));
  const response = await storesec_u.usersDeleteFetch(payload);
  // console.log('del res : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        closeModalElement('deleteUserModal')
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi('del')
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

// ฟังก์ชันสำหรับเปิดโหมดหน้าต่างใช้งานจากตารางย่อยหลัก (Sub-table)
function openAssignShopModal(row) {
  isEditMode.value = false
  assignSingleForm.value = {
    uid: '',
    userUid: row.uid || '',
    groupUid: row.groupUid || '',
    shopUid: '',
    userLevel: row.userLevel || 'user',
    businessRole: '',
    employeeNumber: row.employeeNumber || '',
    nameTh: row.nameTh || '',
    version: 0
  }
  openModalElement('assignShopModal')
}


// ฟังก์ชันสำหรับเปิดโหมดหน้าต่างใช้งานจากตารางย่อยหลัก (Sub-table)
function openEditAssignShopModal(row, shop) {
  isEditMode.value = true
  assignSingleForm.value = {
    uid: shop.uid || '',
    userUid: row.uid || '',
    groupUid: row.groupUid || '',
    shopUid: shop?.shopUid ? String(shop.shopUid).trim() : '',
    userLevel: row.userLevel || 'user',
    businessRole: shop?.businessRole || '',
    employeeNumber: row.employeeNumber || '',
    nameTh: row.nameTh || '',
    version: shop.version !== undefined ? shop.version : 0
  }
  openModalElement('assignShopModal')
}

// ฟังก์ชันประมวลผล แปลงโครงสร้างอาเรย์ และนำส่งคำขอเซฟบันทึกไปยัง API
const handleAssignShop = async () => {
  try {
    const payload = {
      uid: assignSingleForm.value.uid,
      groupUid: key.groupUid,
      userUid: assignSingleForm.value.userUid,
      shopUid: assignSingleForm.value.shopUid,
      userLevel: assignSingleForm.value.userLevel,
      businessRole: assignSingleForm.value.businessRole,
      workHours: [],
      version: assignSingleForm.value.version
    }

    // 3. ตรวจสอบสถานะเพื่อแยกการยิง API ระหว่างแก้ไข และ เพิ่มใหม่
    if (isEditMode.value) {
     const response = await storesec_ur.usersRoleUpdateFetch(payload);
      // console.log('del res : ' + JSON.stringify(response.data));
      if (response) {
        if (response.status === 200) {
          if (response.data.rtnDesc === "success") {
            closeModalElement('assignShopModal')
            swal("บันทึกสำเร็จ", "", "success");
          } else {
            swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
          }
        }
      }
    } else {
      const response = await storesec_ur.usersRoleAddFetch(payload);
      // console.log('del res : ' + JSON.stringify(response.data));
      if (response) {
        if (response.status === 200) {
          if (response.data.rtnDesc === "success") {
            closeModalElement('assignShopModal')
            swal("บันทึกสำเร็จ", "", "success");
          } else {
            swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
          }
        }
      }
    }
    refreshTableData(assignSingleForm.value.userUid)     // ฟังก์ชันสั่งโหลดข้อมูลตารางคนทำงานใหม่ เพื่ออัปเดตสถานะล่าสุด
  } catch (error) {
    console.error('เกิดข้อผิดพลาดในการบันทึกข้อมูลสาขา:', error)
    alert('บันทึกข้อมูลไม่สำเร็จ กรุณาตรวจสอบข้อมูลอีกครั้ง')
  }
}

const isFormAssignShopInvalid = computed(() => {
  if (!assignSingleForm.value.shopUid) return true
  if (!assignSingleForm.value.businessRole) return true
  return false
})

function openSetPinModal(userRow, shopItem) {
  // ดึงรหัสย่อสาขามาแสดงผลบนหัวข้อ Modal เพื่อความชัดเจน
  const matchedShop = shopList.value.find(s => s.uid === shopItem.shopUid)
  
  setPinForm.value = {
    uid: userRow.uid || '',
    userUid: userRow.uid || '',
    groupUid: userRow.groupUid || '',
    shopUid: shopItem.shopUid || '',
    shopCode: matchedShop ? matchedShop.code : 'NW',
    employeeNumber: userRow.employeeNumber || '',
    nameTh: userRow.nameTh || '',
    pin: '',        // รีเซ็ตช่องพิมพ์รหัสใหม่ให้ว่างเปล่า
    confirmPin: ''  // รีเซ็ตช่องยืนยันให้ว่างเปล่า
  }

  openModalElement('setPinModal')
}

const handleSetPin = async () => {
  // 1. ตรวจเช็กความยาวตัวเลขพินให้ครบถ้วน 4 หลักพอดีตามเงื่อนไข UI
  if (!setPinForm.value.pin || setPinForm.value.pin.length !== 4) {
    swal("กรุณากรอกรหัส PIN ให้ครบ 4 หลัก", "", "warning");
    return
  }

  const payload = {
    uid: setPinForm.value.uid,       // แมปเข้าคีย์ uid ตามภาพโค้ดของคุณ
    groupUid: setPinForm.value.groupUid,  // แมปเข้าคีย์ groupUid ตามภาพโค้ดของคุณ
    pin: setPinForm.value.pin             // แมปเข้าคีย์ pin ตามภาพโค้ดของคุณ
  }

  try {
   const response = await storesec_u.usersSetPinFetch(payload);
      // console.log('del res : ' + JSON.stringify(response.data));
      if (response) {
        if (response.status === 200) {
          if (response.data.rtnDesc === "success") {
            closeModalElement('setPinModal')
            swal("บันทึกสำเร็จ", "", "success");
          } else {
            swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
          }
        }
    }
  } catch (error) {
    console.error('เกิดข้อผิดพลาดไม่สามารถบันทึกรหัส PIN ได้:', error)
    alert('เกิดข้อผิดพลาดในการตั้งรหัส PIN กรุณาลองใหม่อีกครั้ง')
  }
}

// 2. ฟังก์ชันจับข้อมูลแถวตารางย่อย แมปค่าสเกล และสั่งกางเปิดหน้าต่างยืนยัน
function openRemoveShopModal(userRow, shopItem) {
  // ค้นหารายละเอียดชื่อเต็มและรหัสสาขาจากใน shopList กลางของหน้าเว็บ
  const matchedShop = shopList.value.find(s => s.uid === shopItem.shopUid)

  removeShopForm.value = {
    uid: shopItem.uid || '',
    userUid: userRow.uid || '',
    shopUid: shopItem.shopUid || '',
    shopCode: matchedShop ? matchedShop.code : 'NW',
    shopName: matchedShop ? matchedShop.nameTh : 'ชื่อสาขา',
    userNameTh: userRow.nameTh || ''
  }

  openModalElement('removeShopModal')
}

const handleRemoveShopSubmit = async () => {
  // ขึ้นรูปก้อน Payload โครงสร้างอ้างอิงพารามิเตอร์ตามมาตรฐานดีไซน์ของหลังบ้าน
  const payload = {
    uid: removeShopForm.value.uid,
  }

  try {
        const response = await storesec_ur.usersRoleDeleteFetch(payload);
          // console.log('del res : ' + JSON.stringify(response.data));
          if (response) {
            if (response.status === 200) {
              if (response.data.rtnDesc === "success") {
                closeModalElement('removeShopModal')
                refreshTableData(removeShopForm.value.userUid)   
                swal("บันทึกสำเร็จ", "", "success");
              } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
              }
            }
          }
  
  } catch (error) {
    console.error('เกิดข้อผิดพลาดในการลบสิทธิ์สาขา:', error)
  }
}

// ฟังก์ชันสำหรับดึงข้อมูลใหม่เพื่อรีเฟรชตารางหน้าจอ
const refreshTableData = async (uid) => {
  if (!uid) {
    expandedRowData.value = []
    return
  }
  expandedRowData.value = null
  try {
    const payload = {
      index: 0,
      size: 30,
      userLevel: 'user',
      shopUid: '',
      userUid: uid,
      businessRole: '',
    }

    const response = await storesec_ur.usersRoleListFetch(payload)
  
    if (response && response.status === 200 && response.data?.rtnDesc === "success") {
      expandedRowData.value = response?.data?.data?.list || []
      return // จบการทำงานสำเร็จ
    }

    expandedRowData.value = []

  } catch (error) {
    console.error('ดึงข้อมูลรายละเอียดพนักงานไม่สำเร็จ:', error)
    expandedRowData.value = []
  }
}

// ฟังก์ชันส่วนกลางสำหรับเรียกใช้ Bootstrap Modal
function openModalElement(modalId) {
  const modalElement = document.getElementById(modalId)
  if (modalElement) {
    const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement)
    modalInstance.show()
  }
}

// ฟังก์ชันส่วนกลางสำหรับเรียกใช้ Bootstrap Modal
function closeModalElement(modalId) {
  const modalElement = document.getElementById(modalId)
  if (modalElement) {
    const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement)
    modalInstance.hide()
  }
}

</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-row-hover:hover {
  background-color: #f8f9fa !important;
}

/* ตกแต่งช่องพิมพ์รหัสอินพุตผ่านคลาสพิเศษให้ตัวอักษรกลมและหนาได้สมดุล */
.custom-pin-dots {
  font-family: 'Courier New', Courier, monospace !important; /* ช่วยขยายระยะจุดกลมให้เท่ากัน */
  background-color: #f8fafc !important;
  transition: all 0.2s ease-in-out;
}

.custom-pin-dots:focus {
  background-color: #ffffff !important;
  border-color: #a855f7 !important;
  box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.15) !important;
}

/* ปรับระยะขอบของปุ่มปิดกากบาทขาวบน Header */
.btn-close-white {
  filter: invert(1) grayscale(1) brightness(2);
}



</style>